<template>
    <div>
        <home-detail>
            <template #main>
                <p>
                    Our company, founded in 2006, provides casting for films, documentaries, commercials and any
                    audiovisual works.
                </p>
                <p>
                    We will prepare voice or face casting according to your specifications. Please send us your brief or
                    call for more information.
                </p>
                <hr />

                <h1>OUR SERVICES</h1>
                <ul>
                    <li>Voice casting</li>
                    <li>Face casting</li>
                    <li>Actor voices / photos</li>
                    <li>Including foreign languages</li>
                    <li>Commercial music database</li>
                    <li>Recording studio booking</li>
                    <li>
                        Production services: TV, ONLINE, RADIO ads, company voice mailing, voice boxes, navigations, TTS
                    </li>
                </ul>
                <br /><br />
                <h2>CONTACTS</h2>
                <div class="table table-contacts">
                    <div class="item">
                        <div class="column">
                            <div><span class="name">Henrich Platek</span></div>
                            <div><span class="role">voice & face agent</span></div>
                        </div>
                        <div class="column">
                            <div>
                                <span><span class="icon">phone</span></span>
                                <span><a href="tel:00421905682931">+421 905 682 931</a></span>
                            </div>
                            <div>
                                <span><span class="icon">mail_outline</span></span>
                                <span
                                    ><a href="mailto:henrich.platek@voicecasting.sk"
                                        >henrich.platek@voicecasting.sk</a
                                    ></span
                                >
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="column">
                            <div><span class="name">Silvia Balcová</span></div>
                            <div><span class="role">voice & face agent</span></div>
                        </div>
                        <div class="column">
                            <div>
                                <span><span class="icon">phone</span></span>
                                <span><a href="tel:00421905756176">+421 905 756 176</a></span>
                            </div>
                            <div>
                                <span><span class="icon">mail_outline</span></span>
                                <span><a href="mailto:silvia@voicecasting.sk">silvia@voicecasting.sk</a></span>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="column">
                            <div><span class="name">Peter Surový</span></div>
                            <div><span class="role">voice & face admin</span></div>
                        </div>
                        <div class="column">
                            <div>
                                <span><span class="icon">phone</span></span>
                                <span><a href="tel:00421903439368">+421 903 439 368</a></span>
                            </div>
                            <div>
                                <span><span class="icon">mail_outline</span></span>
                                <span
                                    ><a href="mailto:peter.surovy@voicecasting.sk"
                                        >peter.surovy@voicecasting.sk</a
                                    ></span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <br /><br />
                <h2>COMPANY DETAILS</h2>
                <div class="table">
                    <div><span>Company name:</span> <span>voicecasting s.r.o.</span></div>
                    <div>
                        <span>Residence address:</span>
                        <span>Bottova 8005/05, 811 09 Bratislava – Staré mesto, Slovakia</span>
                    </div>
                    <div><span>ID / IČO:</span> <span>36614041</span></div>
                    <div><span>TAX ID / DIČ:</span> <span>2022214051</span></div>
                    <div><span>VAT ID / IČ DPH:</span> <span>SK2022214051</span></div>
                    <div><span>Bank:</span> <span>UniCreditBank</span></div>
                    <div><span>Account Number:</span> <span>IBAN SK97 1111 0000 0014 9933 9007</span></div>
                    <br />
                    <div>
                        The company is registered in the Commercial Register of the District Court Bratislava I,
                        Section: Sro, Insert No. 41226 / B.
                    </div>
                    <br /><br /><br />
                </div>
            </template>
        </home-detail>
    </div>
</template>
<script>
import HomeDetail from '@/components/Home/HomeDetail.vue';
import NavButton from '@/components/.global/NavButton.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';

export default {
    name: 'About',

    components: {
        HomeDetail,
        NavButton,
        Mp3Player,
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[block='right'] {
    width: 200px;
}

h2 {
    padding: 5px 10px;
    background: #ededed;
    border-radius: 30px;
    font-weight: 900;
}

ul li {
    padding: 2px 0;
}

hr {
    padding-bottom: 20px;
    margin-top: 20px;
}

.table {
    display: flex;
    flex-direction: column;
    margin: 5px 0 0 10px;

    div {
        display: flex;
        & > span {
            padding: 5px;
            &:first-child {
                width: 130px;
                min-width: 130px;
                padding-left: 0px;
            }
            &:last-child {
                font-weight: 700;
            }
        }
    }

    &.table-contacts {
        width: 100%;
        flex-wrap: wrap;
        margin-top: 5px;
        align-items: flex-start;
        flex-direction: column;

        .item {
            width: 100%;
            margin: 8px 0;
            flex-direction: row;

            @media (max-width: 449px) {
                flex-direction: column;
            }

            .column {
                flex-direction: column;

                &:first-child {
                    width: 33%;
                    padding-right: 15px;

                    @media (max-width: 449px) {
                        width: auto;
                    }
                }

                & > div {
                    span {
                        font-weight: 400;
                        padding: 2px 5px 2px 0;

                        &:first-child {
                            width: auto;
                            min-width: auto;
                        }

                        &.name {
                            color: #000;
                            font-weight: 900;
                            font-size: 15px;
                            padding-bottom: 0;
                            line-height: 1;
                        }

                        &.role {
                            padding-top: 0;
                        }
                    }

                    .icon {
                        display: block;
                        font-size: 17px;
                    }
                }
            }
        }

        a {
            color: #555;
            font-weight: 600;
            word-break: break-all;
            text-decoration: none;

            &:hover {
                color: @accent;
            }
        }

        h3 {
            margin: 0;
        }
    }
}
</style>
